import { useCallback, useEffect, useState } from 'react'
import {useDispatch, useSelector} from 'react-redux'
import { useHistory } from 'react-router-dom'
import {
    klarna_order_place_order,
    billingPlaceOrder,
    pay_by_order,
    zip_pay_order,
    checkout_getparams,
    pay_ws_Ebanx,
    pay_request_EBanx, getStripeClient
} from '../../../../../../api'

import { action_fetch_credit_order } from '../../../../../../store/actions/pages/cart'

import Cache from '../../../../../../utils/cache'
import { __Pay_Ebanx_Debet__, __Pay_Ebanx__ } from '../../../../../../utils/paymethods'
import { useLogin } from '../../../../../hooks/common'
import useCreditPay from '../../credit-pay/credits/hooks/credit-pay'
import {loadStripe} from "@stripe/stripe-js";
import getPublicKey from "../../../../../utils/get-public-key";


export default (options = {}) => {

    const history = useHistory()
    const isLogin = useLogin()
    const dispatch = useDispatch()

    const {
        klarnas,
        payMethod,
        onError,
        inputOrder,
        selectedCard,
        redirectType,
        isFastPayment,
        setShowStripeIdeal
    } = options


    const {
        pay: creditPay,
        paying: creditPaying,
    } = useCreditPay({
        onError
    })

    const [paying, setPaying] = useState(false)

    const global = useSelector(state => state.global)

    const submit = useCallback(result => {
        const { payURL, params } = result
        const form = document.createElement('form')
        form.style.display = 'none'
        form.setAttribute('method', 'POST')
        form.setAttribute('action', payURL)
        let input
        for (let key in params) {
            input = document.createElement('input')
            input.setAttribute('type', 'hidden')
            input.setAttribute('name', key)
            input.setAttribute('value', params[key])
            form.appendChild(input)
        }
        document.body.appendChild(form)
        form.submit()
        // document.body.removeChild(form)
    }, [])



    const placeOrder = useCallback(async () => {

        if(inputOrder) return Promise.resolve(inputOrder)

        const response = await billingPlaceOrder(isFastPayment)
        if (response?.code === 200 && response?.result) {
            if(isLogin){
                //ebanx 跳转到老界面 不能带这个参数
                // if(payMethod && __Pay_Ebanx_Debet__ !== payMethod.id && __Pay_Ebanx__ !== payMethod.id){
                //     Cache.set('temp-order', response?.result?.id)
                // }
            }
            return response?.result
        } else {
            onError({
                message: response?.result || 'Network Error',
                code: response?.code,
                type: (response?.code === 407 || response?.code === 402) ? 'force_refresh' : null
            })
            return null
        }
    }, [payMethod, inputOrder])

    const payKlarna = useCallback(async (opts) => {

        const _klarnas = opts?.klarnas || klarnas


        if(!_klarnas || !_klarnas.shipping_address) return
        setPaying(true)
        const order = await placeOrder()
        if (!order) {
            setPaying(false)
            return
        }

        if(order.isFree){
            window.location.href = `/order-confirm/${order.transactionId}?transactionId=${order.transactionId}`
            return
        }

        window.Klarna.Payments.authorize({
            payment_method_category: payMethod.description
        }, {
            'shipping_address': _klarnas.shipping_address,
            'billing_address': _klarnas.shipping_address
        }, async res => {
            const {
                authorization_token,
                approved,
                show_form,
                error
            } = res

            if (approved && authorization_token) {

                const response = await klarna_order_place_order({ authorizationToken: authorization_token, payMethod: payMethod.id, orderId: order.id })

                if (response?.code === 200 && response?.result) {
                    const {
                        order_id,
                        redirect_url,
                        fraud_status,
                        authorized_payment_method,
                        correlation_id,
                        error_code,
                        error_messages
                    } = response.result

                    if (error_code) {
                        onError({
                            message: error_messages,
                            orderId: order.id,
                            type: 'go_unpaid'
                        })
                    } else if (fraud_status === 'ACCEPTED') {
                        window.location.href = redirect_url
                    }
                }else{
                    onError({
                        message: response?.result,
                        orderId: order.id,
                        type: 'go_unpaid'
                    })
                }

            } else {
                try {
                    if (window.GeekoSensors) {
                        window.GeekoSensors.Track('pay_error', {
                            pay_method: payMethod.id,
                            error: error ? JSON.stringify(error) : ''
                        })
                    }
                } catch (e) {
                    console.error(e)
                }

                if(isLogin){
                    onError({
                        message: error ? JSON.stringify(error) : '',
                        orderId: order.id,
                        type: 'go_unpaid'
                    })
                }else{
                    onError({
                        message: error ? JSON.stringify(error) : ''
                    })
                }
            }

            setPaying(false)
        })
    }, [klarnas, payMethod])

    const payStripeKlarna = useCallback(async (opts) => {
        console.log("payKlarnaV2")
        setPaying(true)
        const order = await placeOrder()
        if (!order) {
            setPaying(false)
            return
        }
        const { config } = global
        const stripe = await loadStripe(getPublicKey(config?.paykeys?.stripe?.publicKey, payMethod.id))
        if (!stripe ) return;
        const data = await getStripeClient({ orderId: order?.id, payMethod:payMethod?.id })
        if(data.code!=200){
            return
        }
        const { clientSecret } = data.result;
        stripe.confirmKlarnaPayment(clientSecret,{
            payment_method: {
            },
            // return_url: `${window.location.origin}/cart/stripe-klarna-success?transactionId=${order.transactionId}&payMethod=${payMethod.id}`, // 成功后跳转地址
            return_url: `${window.location.origin}/api/geekopay/success/web?transactionId=${order.transactionId}&payMethod=${payMethod.id}`, // 成功后跳转地址
        }).then(result => {
            setPaying(false)
        }).catch(error => {
            setPaying(false)
        });
    }, [klarnas, payMethod])

    const payStripeIdeal=async () =>{
        setShowStripeIdeal(true)
    }

    const payByOrder = async () => {
        setPaying(true)
        const order = await placeOrder()
        if (!order) {
            setPaying(false)
            return
        }
        if(order.isFree){
            window.location.href = `/order-confirm/${order.transactionId}?transactionId=${order.transactionId}`
            return
        }
        const response = await pay_by_order({ payMethod: payMethod.id, orderId: order.id, redirectType })
        if (response?.code === 200 && response?.result) {
            const { isFree, success, transactionId, redirectCheckoutUrl, details } = response.result
            if (success) {
                if (redirectCheckoutUrl) {
                    window.location.href = redirectCheckoutUrl
                } else {
                    window.location.href = `/order-confirm/${transactionId}`
                }
            } else {
                onError({
                    message: details || 'Network Error',
                    orderId: order.id,
                    type: 'go_unpaid'
                })
            }
        } else {
            onError({
                message: response?.result || 'Network Error',
                orderId: order.id,
                type: 'go_unpaid'
            })
        }
        setPaying(false)
    }

    const payByZip = async () => {
        setPaying(true)
        const order = await placeOrder()
        if (!order) {
            setPaying(false)
            return
        }
        if(order.isFree){
            window.location.href = `/order-confirm/${order.transactionId}?transactionId=${order.transactionId}`
            return
        }
        const response = await zip_pay_order({ payMethod: payMethod.id, orderId: order.id, redirectType })
        if (response?.code === 200 && response?.result) {
            const {
                key, details
            } = response?.result

            if (key) {
                window.location.href = key
            } else if (details) {
                onError({
                    message: details || 'Network Error',
                    orderId: order.id,
                    type: 'go_unpaid'
                })
            }

        } else {
            onError({
                message: response?.result || 'Network Error',
                orderId: order.id,
                type: 'go_unpaid'
            })
        }
        setPaying(false)
    }

    const payEbanx = async () => {
        setPaying(true)
        const order = await placeOrder()
        if (!order) {
            setPaying(false)
            return
        }
        if(order.isFree){
            window.location.href = `/order-confirm/${order.transactionId}?transactionId=${order.transactionId}`
            return
        }

        const fetchEbanx = payMethod.type === '40' ? pay_ws_Ebanx : pay_request_EBanx

        const response = await fetchEbanx({ payMethod: payMethod.id, orderId: order.id, redirectType })

        if (response?.code === 200 && response?.result) {
            const { transactionId, redirect, isFree } = response?.result
            if (isFree) {
                window.location.href = `/order-confirm/${transactionId}`
            } else if (redirect) {
                window.location.href = redirect
            }
        } else {
            onError({
                message: response?.result || 'Network Error',
                orderId: order.id,
                type: isLogin ? 'go_unpaid': ''
            })
            setPaying(false)
        }
        
    }

    const payCredit = async () => {
        setPaying(true)
        const order = await placeOrder()
        if (!order) {
            setPaying(false)
            return
        }
        if(order.isFree){
            window.location.href = `/order-confirm/${order.transactionId}?transactionId=${order.transactionId}`
            return
        }

        if(__Pay_Ebanx__ === payMethod.id || __Pay_Ebanx_Debet__ === payMethod.id){
            window.location.href =`/cart/credit/${order.id}?payMethod=${payMethod.id}&redirectType=${redirectType}`
        }else{
            if(selectedCard && payMethod.type === '30'){
               const response = await dispatch(action_fetch_credit_order(order.id, selectedCard.quickpayRecord?.payMethod))
               
               if(response?.code === 200 && response?.result){
                    creditPay(null, response.result)
               }else{
                    onError({
                        message: response?.result || 'Network Error',
                    })
               }
            }else{
                // history.push(`/cart/credit-card/${order.id}?payMethod=${payMethod.id}&redirectType=${redirectType}`)
                window.location.href =`/cart/credit-card/${order.id}?payMethod=${payMethod.id}&redirectType=${redirectType}`
            }
        }
        
        setPaying(false)
    }

    const payGoByParams = async () => {
        setPaying(true)
        const order = await placeOrder()
        if (!order) {
            setPaying(false)
            return
        }
        if(order.isFree){
            window.location.href = `/order-confirm/${order.transactionId}?transactionId=${order.transactionId}`
            return
        }
        const response = await checkout_getparams({ orderId: order.id, payMethod: payMethod.id, redirectType })
        if (response?.code === 200 && response?.result) {
            submit(response?.result)
        } else {
            onError({
                message: response?.result || 'Network Error',
                orderId: order.id,
                type: 'go_unpaid'
            })
            setPaying(false)
        }
    }

    const pay = (opts) => {
        switch (payMethod.type) {
            case '27':
                payKlarna(opts)
                break
            case '45':
                payStripeKlarna(opts)
                break
            case '28':
                payByOrder()
                break
            case '36':
                payByZip()
                break
            case '8':    
            case '30':
                payCredit()
                break
            case '38':
                payGoByParams()
                break
            case '39':
            case '40':
                payEbanx()
                break
            case '46':
                payStripeIdeal()
                break
            default:
                break
        }
    }

    return {
        paying: paying || creditPaying,
        pay
    }
}